
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import DriverList from './List';
import DriverAdd from './Add';
import DriverDetail from './Detail';


export default class DriverRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/driver" exact component={DriverList} />
        <Route path="/driver/add" exact component={DriverAdd} />
        <Route path="/driver/:id" component={DriverDetail} />
      </Switch>
    );
  }
}
